import React from 'react';
import { SettingsBreadcrumbs } from '../../../settingsModule';
import useSettingsNavigator from '../../../settingsNavigator';
import { Breadcrumb } from '../../../../shared/web/layout/Breadcrumbs';

export default function MarketRequestsBreadcrumbs(
  props: {
    children?: React.ReactNode,
  }
) {
  const settingsNavigator = useSettingsNavigator();
  return (
    <SettingsBreadcrumbs>
      <Breadcrumb text="Market Requests" href={settingsNavigator.getAdminMarketRequestsLink()}>
        {props.children}
      </Breadcrumb>
    </SettingsBreadcrumbs>
  );
}
